import { ResearchGridBase } from "../models/research-grid-page.model";
import * as ResearchGridActions from "../actions/research-grid-page.actions";

const initialState: ResearchGridBase = {
  gridFilters: {
    companyId: [],
    //analystEmailId: [],
    analystId: [],
    primaryCo: 1,
    page: 1,
    publisherIds: [],
    date: {
      startDate: "",
      endDate: "",
    },
    sortBy: "",
    sortOrder: "desc",
    pageCount: [],
    pageSize: 50,
  },
};

export function researchGridReducer(
  state: ResearchGridBase = initialState,
  action: ResearchGridActions.Actions,
) {
  switch (action.type) {
    case ResearchGridActions.SET_RESEARCH_BASE:
      return {
        ...state,
        gridFilters: action.payload.gridFilters,
      };
    case ResearchGridActions.CHANGE_FILTER:
      return {
        ...state,
        gridFilters: {
          ...action.payload,
        },
      };
    case ResearchGridActions.CHANGE_DATE_FILTER:
      return {
        ...state,
        gridFilters: {
          ...state.gridFilters,
          page: 1,
          date: {
            ...action.payload,
          },
        },
      };

    case ResearchGridActions.RESET_FILTER:
      return {
        ...state,
        gridFilters: {
          ...initialState.gridFilters,
          ...action.payload,
        },
      };

    default:
      return state;
  }
}
